const createdTime = order => {
  const value = order.created_at ?? order.originalOrder?.created_at ?? order.createdAt;
  if (value == null || value === "") return -Infinity;
  const time = new Date(value).getTime();
  return Number.isFinite(time) ? time : -Infinity;
};
/** Newest first; missing/invalid dates stay last and equal dates retain source order. */
export const compareOrdersNewestFirst = (first, second) => {
  const firstTime = createdTime(first);
  const secondTime = createdTime(second);
  return firstTime === secondTime ? 0 : secondTime > firstTime ? 1 : -1;
};
